<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro de Transporte de Mercancías Específico</h1>
                <p>¿Su empresa debe movilizar ocasionalmente productos terminados o materias primas? Si es así, esta
                solución le permite amparar las pérdidas o daños que sus bienes sufran con motivo del transporte.
                </p>
        </div>
        <div class="services">
            <center>
                <h1>Con este seguro su empresa podrá:</h1>
                <div v-for="(slide, i) in slides" :key="i">
                    <div v-for="(service, y) in slide.service" :key="y">
                        <div class="service-img">
                            <div>
                                <img :src="service.img" alt="">
                                <p v-html="service.text"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>El hurto, extravío, accidentes del vehículo transportador, daños durante las operaciones de cargue y descargue, derrumbes, inundación,
                incendio, entre otros hechos, son riesgos comunes a los que están expuestas sus mercancías durante movilizaciones urbanas,
                nacionales, importaciones o exportaciones en diferentes modos de transporte (aéreo, marítimo, terrestre, férreo o fluvial).
                <br>
                <br>
                El Seguro de Transporte de Mercancías Específico es una solución sólida que le permite proteger un envío de mercancías en particular, es decir
                que esta solución solo opera para un despacho y, por lo tanto, deberá ser tomada con anticipación a dicho envío. Si posteriormente su
                empresa realiza otras movilizaciones, deberá tomar un seguro adicional para cada una de ellas.
                <br>
                <br>
                Este seguro tiene una estructura todo riesgo, es decir que se amparan todos los riesgos excepto aquellos excluidos en el condicionado general.
                <span></span></p>
            </center>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <h1>{{service.label}}</h1>
                        <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                        <p>Coberturas principales</p>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
                <div v-if="service.type" class="inboxin">
                    <center><h1>Coberturas opcionales</h1></center>
                    <div v-for="(p, y) in service.opcionales" :key="y" class="opcional">
                        <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p>
                    </div>
                </div>
                <div v-else>
                    <div class="imgbox right">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box2">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
                 <div v-if="!service.type" class="inboxin">
                    <center><h1>¿Qué empresas y equipos se pueden asegurar?</h1></center>
                    <div v-for="(p, i) in service.opcionales" :key="i" class="opcional">
                        <p>{{p}}</p>
                    </div>
                    <center><h1>¿Qué empresas se pueden asegurar?</h1></center>
                    <div v-for="(p, i) in service.opcionalesb" :key="i" class="opcional">
                        <p>{{p}}</p>
                    </div>
                    <center><h1>¿Cuál es el valor asegurable?</h1></center>
                    <div v-for="(p, i) in service.opcionalesc" :key="i" class="opcional">
                        <p>{{p}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="info">
            <h1>Seguro de Transporte de Mercancías Automático</h1>
            <p>¿Su empresa debe transportar con frecuencia productos terminados o materias primas? Si es así, esta
            solución le permite amparar las pérdidas o daños que sus bienes sufran con ocasión del transporte.
            </p>
        </div>
        <div class="especialidades-slide">
            <center><h1>Con el Seguro de Protección Digital Empresas puede:</h1>
            <VueSlickCarousel
                class="slider2"
                ref="slick"
                v-bind="slickOptionsExperiencies"
                :arrows="false">
                <div v-for="(slide, i) in especialidades" :key="i" class="especial">
                    <img :src="slide.image" alt="">
                    <p>{{slide.texto}}</p>
                </div>
            </VueSlickCarousel>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>El hurto, extravío, accidentes del vehículo transportador, daños durante las operaciones de cargue y descargue, derrumbes, inundaciones,
                incendios, entre otros, son riesgos comunes a los que están expuestas sus mercancías durante movilizaciones urbanas, nacionales,
                importaciones o exportaciones en los diferentes modos de transporte (aéreo, marítimo, terrestre, férreo o fluvial).
                <br>
                <br>
                El Seguro de Transporte de Mercancías Automático es una solución sólida que le permite proteger los envíos de sus mercancías de forma
                automática, es decir que no requieren un reporte previo de cada despacho que su empresa realice para gozar de protección.
                <br>
                <br>
                Este seguro tiene una estructura todo riesgo, así que se amparan todos los factores que pueden afectar sus traslados, excepto los excluidos en
                el condicionado general.
                <span></span></p>
            </center>
        </div>
        <div class="cubrimos">
            <div class="service" v-for="(service, i) in services2" :key="i">
                <div v-if="service.type">
                    <div class="imgbox">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box">
                        <h1>{{service.label}}</h1>
                        <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                        <p>Coberturas principales</p>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
                <div v-if="service.type" class="inboxin">
                    <center><h1>Coberturas opcionales</h1></center>
                    <div v-for="(p, y) in service.opcionales" :key="y" class="opcional">
                        <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p>
                    </div>
                </div>
                <div v-else>
                    <div class="imgbox right">
                        <img :src="service.img" alt="">
                    </div>
                    <div class="box2">
                        <h1>{{service.label}}</h1>
                        <div v-for="(p, y) in service.p" :key="y">
                            <div><font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p></div>
                        </div>
                    </div>
                </div>
                 <div v-if="!service.type" class="inboxin">
                    <center><h1>¿Qué bienes no aseguramos?</h1></center>
                    <div v-for="(p, i) in service.opcionales" :key="i" class="opcional">
                        <p>{{p}}</p>
                    </div>
                    <center><h1>¿Qué empresas se pueden asegurar?</h1></center>
                    <div v-for="(p, i) in service.opcionalesb" :key="i" class="opcional">
                        <p>{{p}}</p>
                    </div>
                    <center><h1>¿Cuál es el valor asegurable?</h1></center>
                    <div v-for="(p, i) in service.opcionalesc" :key="i" class="opcional">
                        <p>{{p}}</p>
                    </div>
                </div>
            </div>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Seguro-trans-mercancias-especifico/4.png'),
                    texto: 'Asegurar de forma automática los envíos de mercancías contra riesgos de pérdidas y daños.'
                },
                {
                    image: require('@/assets/Seguro-trans-mercancias-especifico/5.png'),
                    texto: 'Cubrir despachos urbanos, nacionales, importaciones y exportaciones.'
                },
                {
                    image: require('@/assets/Seguro-trans-mercancias-especifico/6.png'),
                    texto: 'Tener cobertura para diferentes tipos de mercancías.'
                },
                {
                    image: require('@/assets/Seguro-trans-mercancias-especifico/7.png'),
                    texto: 'Recibir acompañamiento en soluciones de administración de riesgos.'
                }
            ],
            services: [
                {
                    type: true,
                    img: require('@/assets/Seguro-trans-mercancias-especifico/8.png'),
                    label: '¿Qué cubre?',
                    p: [
                        'Hurto, extravío, accidente del vehículo transportador, incendio, rayo, explosión y, en general, todos los riesgos de pérdidas y daños de los bienes movilizados con ocasión del transporte en operaciones urbanas, nacionales, importaciones y exportaciones en los diferentes modos de transporte (aéreo, marítimo, terrestre, férreo y fluvial).',
                        'En el transporte marítimo se ampara la avería gruesa (acción o inversión extraordinaria para salvar los bienes en riesgo), los gastos de salvamento y la responsabilidad en las partes involucradas por colisión.',
                        'Para importaciones y exportaciones se brinda un auxilio del 10 % sobre el valor de la indemnización (luego de aplicar el deducible).',
                        'Cubrimos los gastos para preservar los bienes movilizados de una pérdida o daño mayor a causa de un riesgo amparado por el seguro (máximo el 10 % del valor asegurado).',
                        'Gastos de remoción de escombros, desmantelamiento, destrucción y disposición final de elementos que hayan sufrido afectaciones por un riesgo amparado por el seguro.',
                        'Pérdidas y daños de mercancías refrigeradas y a granel (sin ningún empaque).',
                        'Permanencias o estadías de las mercancías en puertos, aeropuertos y otros sitios durante el curso ordinario de tránsito.',
                        'Protegeremos los contenedores utilizados en el transporte de las mercancías aseguradas y por los que su empresa sea responsable.',
                        'Pérdidas y daños durante las operaciones de cargue y descargue.'
                    ],
                    title: 'Coberturas opcionales',
                    opcionales: [
                        'Acciones de huelguistas y personas malintencionadas.',
                        'Eventos de guerra internacional, guerra civil o rebelión.',
                        'Protección de maquinaria y bienes usados.'
                    ]
                },
                {
                    type: false,
                    img: require('@/assets/Seguro-trans-mercancias-especifico/9.png'),
                    label: '¿Qué no cubre?',
                    title: '¿Qué bienes no aseguramos?',
                    p: [
                        'Huelga, suspensión de trabajo, disturbios laborales, asonada, motín y conmoción civil.',
                        'Infidelidad y acciones deshonestas por parte de administradores y trabajadores al servicio del asegurado.',
                        'Lucro cesante (dejar de percibir ingresos por no poder ejecutar las actividades económicas de su empresa).',
                        'Responsabilidad civil de cualquier tipo.',
                        'Multas o sanciones.',
                        'Toma de muestras y demás actos de las autoridades competentes.',
                        'Vicio propio, descomposición natural y combustión espontánea de los bienes movilizados.',
                        'Daños por condensación.',
                        'Deterioros causados por el simple transcurso del tiempo.',
                        'Riesgos de energía nuclear y contaminación radioactiva.',
                        'Contaminación y polución paulatina.',
                        'Errores o faltantes en el despacho o por haber despachado los bienes en mal estado.',
                        'Insuficiencia del empaque o haber preparado indebidamente los bienes para los riesgos ordinarios de tránsito.',
                        'Demoras o pérdidas de mercado.',
                        'Ataques cibernéticos y riesgos de tecnología de la información.',
                        'Pérdidas relacionadas directa o indirectamente con el asbesto.',
                        'Transporte en vehículos terrestres con una edad superior a 25 años, salvo que hayan sido repotenciados.'
                    ],
                    opcionales: [
                        'No se asegura el transporte de algodón, objetos personales y enseres domésticos, monedas, billetes, joyas, metales preciosos, billetes de lotería, acciones, cheques o cualquier clase de documento que tenga un valor económico e información almacenada en discos, USB o medios electrónicos.'
                    ],
                    opcionalesb: [
                        'Aquellas que sean propietarias de las mercancías movilizadas (generadores de carga). Este seguro no aplica para empresas transportadoras.'
                    ],
                    opcionalesc: [
                        'Estará compuesto por el valor de la mercancía incluyendo fletes, impuestos, costos de embalaje, seguros y gastos adicionales en puertos.'
                    ]
                }
            ],
            slides: [
                {
                    service: [
                        {
                            text: 'Proteger un envío de mercancías urbano, nacional, de importación o exportación frente a pérdidas y daños.',
                            img: require('@/assets/Seguro-trans-mercancias-especifico/1.png')
                        },
                        {
                            text: 'Respaldar diferentes tipos de mercancías.',
                            img: require('@/assets/Seguro-trans-mercancias-especifico/2.png')
                        },
                        {
                            text: 'Contar con acompañamiento en soluciones de administración de riesgos.',
                            img: require('@/assets/Seguro-trans-mercancias-especifico/3.png')
                        }
                    ]
                }
            ],
            services2: [
                {
                    type: true,
                    img: require('@/assets/Servicio1.png'),
                    label: '¿Qué cubre?',
                    p: [
                        'Lo protegemos en caso de hurto, extravío, accidente del vehículo transportador, incendio, rayo, explosión y, en general, todos los riesgos de pérdidas y daños de los bienes movilizados con ocasión del transporte (excepto aquellos excluidos) en operaciones urbanas, nacionales, importaciones y exportaciones en diferentes modos de transporte (aéreo, marítimo, terrestre, férreo y fluvial).',
                        'En el transporte marítimo se amparan las contribuciones por avería gruesa (acción o inversión extraordinaria para salvar los bienes en riesgo), gastos de salvamento y responsabilidad de las partes involucradas por colisión.',
                        'Para importaciones y exportaciones se brinda un auxilio del 10 % sobre el valor de la indemnización (luego de aplicar el deducible).',
                        'Cubrimos los gastos para preservar los bienes movilizados de una pérdida o daño mayor debido a un riesgo amparado por este seguro, remoción de escombros y disposición final.',
                        'Lo protegemos en caso de transportar mercancías refrigeradas y granel.',
                        'Asumimos las pérdidas y daños en caso de permanencia o estadía de las mercancías en puertos, aeropuertos y otros sitios durante el curso ordinario de tránsito.',
                        'Protegemos los contenedores que sean utilizados en el transporte de las mercancías aseguradas.',
                        'Cubrimos las pérdidas y daños durante las operaciones de cargue y descargue.'
                    ],
                    title: 'Coberturas opcionales',
                    opcionales: [
                        'Lo protegemos ante la acción de huelguistas y personas malintencionadas.',
                        'Pagamos las pérdidas y daños si su mercancía se ve involucrada en eventos de guerra internacional, guerra civil o rebelión.',
                        'Protección de maquinaria y bienes usados.'
                    ]
                },
                {
                    type: false,
                    img: require('@/assets/Servicio2.png'),
                    label: '¿Qué no cubre?',
                    title: '¿Qué bienes no aseguramos?',
                    p: [
                        'Huelga, suspensión de trabajo, disturbios laborales, asonada, motín y conmoción civil.',
                        'Infidelidad y acciones deshonestas por parte de administradores y trabajadores al servicio del asegurado.',
                        'Lucro cesante (dejar de percibir ingresos por no poder ejecutar las actividades económicas de su empresa).',
                        'Responsabilidad civil de cualquier tipo.',
                        'Multas o sanciones.',
                        'Actos de las autoridades competentes.',
                        'Vicio propio y combustión espontánea.',
                        'Daños por condensación.',
                        'Riesgos de energía nuclear y contaminación radioactiva.',
                        'Contaminación y polución paulatina.',
                        'Errores o faltantes en el despacho o por haber despachado los bienes en mal estado.',
                        'Insuficiencia del empaque o haber preparado indebidamente los bienes para los riesgos ordinarios de tránsito.',
                        'Demoras o pérdidas de mercado.',
                        'Ataques cibernéticos y riesgos de tecnología de la información.',
                        'Transporte realizado en embarcaciones marítimas no clasificadas o aquellas con edad superior a 25 años (15 años para embarcaciones charteadas, es decir las que son contratadas por una empresa únicamente para movilizar su mercancía).',
                        'Transporte en vehículos terrestres con una edad superior a 25 años, salvo que hayan sido repotenciados.'
                    ],
                    opcionales: [
                        'No aseguramos el transporte de algodón, objetos personales y enseres domésticos, monedas, billetes, joyas, metales preciosos, billetes de lotería, acciones, cheques o cualquier clase de documento que tenga valor económico e información almacenada en discos, USB o medios electrónicos.'
                    ],
                    opcionalesb: [
                        'Aquellas propietarias de las mercancías movilizadas (generadores de carga). Este seguro no aplica para empresas transportadoras.'
                    ],
                    opcionalesc: [
                        'El valor asegurable estará compuesto por el costo de la mercancía incluyendo fletes, impuestos, gastos de embalaje, seguros y costos adicionales en puertos.'
                    ]
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .services {
        padding: 50px 300px;
        width: 100%;
    }
    .services > center {
        display: contents;
    }
    .services > center > div {
        display: inline-block;
        width: 100%;
    }
    .services > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 50px;
        font-size: 30px;
    }
    .services > center > div > div {
        display: inline-flex;
        width: 33.333333333%;
        float: left;
    }
    .services > center > div > div > .service-img {
        width: 100%;
    }
    .services > center > div > div > .service-img > div {
        position: relative;
        width: 100%;
        height: 100%;
        padding: auto;
        margin-bottom: 10px;
        transition: margin-top .5s ease-out 100ms;
    }
    .services > center > div > div > .service-img > div:hover {
        margin-top: -10px;
    }
    .services > center > div > div > .service-img > div >  img {
        width: 100%;
        height: auto;
    }
    .services > center > div > div > .service-img > div >  p {
        font-family: 'JR';
        font-size: 18px;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > img {
        width: 50px;
        margin-right: 10px;
    }
    .service > div > .box > p {
        color: #65b24a;
        font-family: 'JBD';
        padding-top: 15px;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > img {
        width: 50px;
        margin-right: 10px;
    }
    .service > div > .box2 > p {
        color: #65b24a;
        font-family: 'JBD';
        padding-top: 15px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > .inboxin {
        display: block;
    }
    .service > .inboxin > center > h1 {
        text-align: center;
        color: #2d4f98;
        font-family: 'JBD';
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
       .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades-slide > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .services {
            padding: 50px 200px;
            width: 100%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .services {
            padding: 50px 50px;
            width: 100%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            padding: 10px;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/seguroTransMercanciasEspecifico.vue